import { GameResponseModel } from 'models';
import baseball from 'assets/images/category/baseball.png';
import basketball from 'assets/images/category/basketball.png';
import boxing from 'assets/images/category/boxing.png';
import cricket from 'assets/images/category/cricket.png';
import esports from 'assets/images/category/esport.png';
import football from 'assets/images/category/football.png';
import golf from 'assets/images/category/golf.png';
import hockey from 'assets/images/category/hockey.png';
import mma from 'assets/images/category/mma.png';
import soccer from 'assets/images/category/soccer.png';
import tennis from 'assets/images/category/tennis.png';

export interface MockSportCategoryProps {
  categoryId: number;
  key: string;
  sportTitle: string;
  sportTitleShort: string;
  sportName: string;
  sportActivity: string;
}

export interface TabProps {
  categoryId: number;
  key: string;
  sportTitle: string;
  categoryName: string;
}

export interface Category {
  category: string;
  tab: string;
}

export interface League {
  sportTitle: string;
  sportActivity: string;
  categoryId: number;
  tab: string;
  id: number;
}

export interface GroupedLeague {
  tab: string;
  leagues: League[];
}

export const sportList = [
  {
    key: 'soccer',
    lable: 'Soccer',
    title: 'tabCategory.soccer',
    image: soccer,
  },
  {
    key: 'football',
    lable: 'Football',
    title: 'tabCategory.football',
    image: football,
  },
  {
    key: 'baseball',
    lable: 'Baseball',
    title: 'tabCategory.baseball',
    image: baseball,
  },
  {
    key: 'basketball',
    lable: 'Basketball',
    title: 'tabCategory.basketball',
    image: basketball,
  },
  {
    key: 'hockey',
    lable: 'Hockey',
    title: 'tabCategory.hockey',
    image: hockey,
  },

  {
    key: 'tennis',
    lable: 'Tennis',
    title: 'tabCategory.tennis',
    image: tennis,
  },
  {
    key: 'golf',
    lable: 'Golf',
    title: 'tabCategory.golf',
    image: golf,
  },
  {
    key: 'cricket',
    lable: 'cricket',
    title: 'tabCategory.cricket',
    image: cricket,
  },
  {
    key: 'mma',
    lable: 'MMA',
    title: 'tabCategory.mma',
    image: mma,
  },
  {
    key: 'esports',
    lable: 'eSports',
    title: 'tabCategory.esports',
    image: esports,
  },
];

export const categoryList: Category[] = [
  { category: '', tab: '' },
  { category: 'football', tab: 'NCAAF' },
  { category: 'baseball', tab: 'MLB' },
  { category: 'basketball', tab: 'NBA' },
  { category: 'hockey', tab: 'NHL' },
  { category: 'soccer', tab: 'EPL' },
  { category: 'tennis', tab: 'ATP' },
  { category: 'golf', tab: 'DP World Tour' },
  { category: 'mma', tab: 'UFC' },
  { category: 'boxing', tab: 'Boxing' },
  { category: 'cricket', tab: 'England - T20 Blast' },
  { category: 'esports', tab: 'League of Legends' },
];

export interface GamesForTab {
  [key: string]: GameResponseModel[];
}

export const initialGamesForTab: GamesForTab = {
  NCAAF: [],
  NFL: [],
  MLB: [],
  NBA: [],
  NCAAB: [],
  WNBA: [],
  'WNBA Preseason': [],
  'WNBA All-Star Game': [],
  'WNBA Commissioner Cup': [],
  NHL: [],
  EPL: [],
  'La Liga - Spain': [],
  MLS: [],
  'UEFA Nations League A': [],
  'UEFA Europa League': [],
  'UEFA Champions League': [],
  'Vietnam V.League 1': [],
  ATP: [],
  WTA: [],
  'ATP French Open': [],
  'ATP Santa Fe Challenger': [],
  'ATP Lyon Challenger': [],
  'ATP Stuttgart': [],
  'ATP Ilkley Challenger': [],
  'ATP Perugia Challenger': [],
  'ATP Hertogenbosch': [],
  'ATP Bratislava Challenger': [],
  'WTA French Open': [],
  'WTA London': [],
  'WTA Hertogenbosch': [],
  'DP World Tour': [],
  PGA: [],
  UFC: [],
  Boxing: [],
  'England - T20 Blast': [],
  'International - Tours': [],
  'International - Tours Women': [],
  'West Indies - Caribbean Premier League': [],
  'League of Legends': [],
  Valorant: [],
  CS2: [],
  'Dota 2': [],
};

export const mockSportCategory: MockSportCategoryProps[] = [
  {
    categoryId: 5,
    key: 'soccer_epl',
    sportActivity: 'Soccer',
    sportTitle: 'EPL',
    sportTitleShort: 'EPL',
    sportName: 'English Premier League',
  },
  {
    categoryId: 5,
    key: 'soccer_spain_la_liga',
    sportActivity: 'Soccer',
    sportTitle: 'La Liga - Spain',
    sportTitleShort: 'LLS',
    sportName: 'Spanish Soccer',
  },
  {
    categoryId: 5,
    key: 'soccer_usa_mls',
    sportActivity: 'Soccer',
    sportTitle: 'MLS',
    sportTitleShort: 'MLS',
    sportName: 'Major League Soccer',
  },
  {
    categoryId: 5,
    key: 'soccer_uefa_nations_league',
    sportActivity: 'Soccer',
    sportTitle: 'UEFA Nations League A',
    sportTitleShort: 'UEFA Nations League A',
    sportName: 'UEFA Nations League A',
  },
  {
    categoryId: 5,
    key: 'soccer_uefa_europa_league',
    sportActivity: 'Soccer',
    sportTitle: 'UEFA Europa League',
    sportTitleShort: 'UEFA Europa League',
    sportName: 'UEFA Europa League',
  },
  {
    categoryId: 5,
    key: 'soccer_uefa_champions_league',
    sportActivity: 'Soccer',
    sportTitle: 'UEFA Champions League',
    sportTitleShort: 'UEFA Champions League',
    sportName: 'UEFA Champions League',
  },
  {
    categoryId: 5,
    key: 'soccer_v_league_1',
    sportActivity: 'Soccer',
    sportTitle: 'Vietnam V.League 1',
    sportTitleShort: 'Vietnam V.League 1',
    sportName: 'Vietnam V.League 1',
  },
  {
    categoryId: 1,
    key: 'americanfootball_ncaaf',
    sportActivity: 'Football',
    sportTitle: 'NCAAF',
    sportTitleShort: 'NCAAF',
    sportName: 'US College Football',
  },
  {
    categoryId: 1,
    key: 'americanfootball_nfl',
    sportActivity: 'Football',
    sportTitle: 'NFL',
    sportTitleShort: 'NFL',
    sportName: 'US Football',
  },
  {
    categoryId: 1,
    key: 'football_futures',
    sportActivity: 'Football',
    sportTitle: 'Futures',
    sportTitleShort: 'Futures',
    sportName: 'US Football',
  },
  {
    categoryId: 2,
    key: 'baseball_mlb',
    sportActivity: 'Baseball',
    sportTitle: 'MLB',
    sportTitleShort: 'MLB',
    sportName: 'Major League Baseball',
  },
  {
    categoryId: 2,
    key: 'baseball_futures',
    sportActivity: 'Baseball',
    sportTitle: 'Futures',
    sportTitleShort: 'Futures',
    sportName: 'Major League Baseball',
  },
  {
    categoryId: 3,
    key: 'basketball_nba',
    sportActivity: 'Basketball',
    sportTitle: 'NBA',
    sportTitleShort: 'NBA',
    sportName: 'US Basketball',
  },
  {
    categoryId: 3,
    key: 'basketball_ncaab',
    sportActivity: 'Basketball',
    sportTitle: 'NCAAB',
    sportTitleShort: 'NCAAB',
    sportName: 'US College Basketball',
  },
  {
    categoryId: 3,
    key: 'basketball_wnba',
    sportActivity: 'Basketball',
    sportTitle: 'WNBA',
    sportTitleShort: 'WNBA',
    sportName: 'WNBA',
  },
  {
    categoryId: 3,
    key: 'basketball_futures',
    sportActivity: 'Basketball',
    sportTitle: 'Futures',
    sportTitleShort: 'Futures',
    sportName: 'US College Basketball',
  },
  {
    categoryId: 4,
    key: 'icehockey_nhl',
    sportActivity: 'Hockey',
    sportTitle: 'NHL',
    sportTitleShort: 'NHL',
    sportName: 'US Ice Hockey',
  },
  {
    categoryId: 4,
    key: 'icehockey_futures',
    sportActivity: 'Hockey',
    sportTitle: 'Futures',
    sportTitleShort: 'Futures',
    sportName: 'US Ice Hockey',
  },

  // {
  //   categoryId: 6,
  //   key: 'tennis',
  //   sportActivity: 'Tennis',
  //   sportTitle: 'ATP',
  //   sportTitleShort: 'ATP',
  //   sportName: 'Tennis',
  // },
  // {
  //   categoryId: 6,
  //   key: 'tennis',
  //   sportActivity: 'Tennis',
  //   sportTitle: 'WTA',
  //   sportTitleShort: 'WTA',
  //   sportName: 'Tennis',
  // },
  // {
  //   categoryId: 7,
  //   key: 'golf',
  //   sportActivity: 'Golf',
  //   sportTitle: 'DP World Tour',
  //   sportTitleShort: 'DP World Tour',
  //   sportName: 'Golf',
  // },
  // {
  //   categoryId: 7,
  //   key: 'golf',
  //   sportActivity: 'Golf',
  //   sportTitle: 'PGA',
  //   sportTitleShort: 'PGA',
  //   sportName: 'Golf',
  // },
];

export const mockMoreSportsCategory: MockSportCategoryProps[] = [
  {
    categoryId: 6,
    key: 'tennis',
    sportActivity: 'Tennis',
    sportTitle: 'ATP',
    sportTitleShort: 'ATP',
    sportName: 'Tennis',
  },
  {
    categoryId: 6,
    key: 'tennis',
    sportActivity: 'Tennis',
    sportTitle: 'WTA',
    sportTitleShort: 'WTA',
    sportName: 'Tennis',
  },
  {
    categoryId: 7,
    key: 'golf',
    sportActivity: 'Golf',
    sportTitle: 'DP World Tour',
    sportTitleShort: 'DP World Tour',
    sportName: 'Golf',
  },
  {
    categoryId: 7,
    key: 'golf',
    sportActivity: 'Golf',
    sportTitle: 'PGA',
    sportTitleShort: 'PGA',
    sportName: 'Golf',
  },
  {
    categoryId: 8,
    key: 'mma',
    sportActivity: 'MMA',
    sportTitle: 'UFC',
    sportTitleShort: 'UFC',
    sportName: 'MMA',
  },
  // {
  //   categoryId: 9,
  //   key: 'boxing',
  //   sportActivity: 'Boxing',
  //   sportTitle: 'Boxing',
  //   sportName: 'Boxing',
  // },
  {
    categoryId: 10,
    key: 'cricket',
    sportActivity: 'Cricket',
    sportTitle: 'England - T20 Blast',
    sportTitleShort: 'T20',
    sportName: 'Cricket',
  },
  {
    categoryId: 10,
    key: 'cricket',
    sportActivity: 'Cricket',
    sportTitle: 'International - Tours',
    sportTitleShort: 'ICT',
    sportName: 'Cricket',
  },
  {
    categoryId: 10,
    key: 'cricket',
    sportActivity: 'Cricket',
    sportTitle: 'International - Tours Women',
    sportTitleShort: 'ICTW',
    sportName: 'Cricket',
  },
  {
    categoryId: 10,
    key: 'cricket',
    sportActivity: 'Cricket',
    sportTitle: 'West Indies - Caribbean Premier League',
    sportTitleShort: 'CPL',
    sportName: 'Cricket',
  },
  {
    categoryId: 11,
    key: 'eSports',
    sportActivity: 'eSports',
    sportTitle: 'League of Legends',
    sportTitleShort: 'LoL',
    sportName: 'eSports',
  },
  {
    categoryId: 11,
    key: 'eSports',
    sportActivity: 'eSports',
    sportTitle: 'Valorant',
    sportTitleShort: 'Valorant',
    sportName: 'eSports',
  },
  {
    categoryId: 11,
    key: 'eSports',
    sportActivity: 'eSports',
    sportTitle: 'CS2',
    sportTitleShort: 'CS2',
    sportName: 'eSports',
  },
  {
    categoryId: 11,
    key: 'eSports',
    sportActivity: 'eSports',
    sportTitle: 'Dota 2',
    sportTitleShort: 'Dota 2',
    sportName: 'eSports',
  },
];

export const allLeague = [...mockSportCategory, ...mockMoreSportsCategory];

export const groupedTennisLeague: GroupedLeague[] = [
  {
    tab: 'ATP',
    leagues: [
      {
        sportTitle: 'ATP',
        sportActivity: 'Tennis',
        categoryId: 6,
        tab: 'ATP',
        id: 1,
      },
      {
        sportTitle: 'ATP French Open',
        sportActivity: 'Tennis',
        categoryId: 6,
        tab: 'ATP',
        id: 2,
      },
      {
        sportTitle: 'ATP Santa Fe Challenger',
        sportActivity: 'Tennis',
        categoryId: 6,
        tab: 'ATP',
        id: 17839,
      },
      {
        sportTitle: 'ATP Lyon Challenger',
        sportActivity: 'Tennis',
        categoryId: 6,
        tab: 'ATP',
        id: 8489,
      },
      {
        sportTitle: 'ATP Stuttgart',
        sportActivity: 'Tennis',
        categoryId: 6,
        tab: 'ATP',
        id: 339,
      },
      {
        sportTitle: 'ATP Ilkley Challenger',
        sportActivity: 'Tennis',
        categoryId: 6,
        tab: 'ATP',
        id: 334,
      },
      {
        sportTitle: 'ATP Perugia Challenger',
        sportActivity: 'Tennis',
        categoryId: 6,
        tab: 'ATP',
        id: 6741,
      },
      {
        sportTitle: 'ATP Hertogenbosch',
        sportActivity: 'Tennis',
        categoryId: 6,
        tab: 'ATP',
        id: 333,
      },
      {
        sportTitle: 'ATP Bratislava Challenger',
        sportActivity: 'Tennis',
        categoryId: 6,
        tab: 'ATP',
        id: 13035,
      },
    ],
  },
  {
    tab: 'WTA',
    leagues: [
      {
        sportTitle: 'WTA',
        sportActivity: 'Tennis',
        categoryId: 6,
        tab: 'WTA',
        id: 3,
      },
      {
        sportTitle: 'WTA French Open',
        sportActivity: 'Tennis',
        categoryId: 6,
        tab: 'WTA',
        id: 4,
      },
      {
        sportTitle: 'WTA London',
        sportActivity: 'Tennis',
        categoryId: 6,
        tab: 'WTA',
        id: 19094,
      },
      {
        sportTitle: 'WTA Hertogenbosch',
        sportActivity: 'Tennis',
        categoryId: 6,
        tab: 'WTA',
        id: 404,
      },
    ],
  },
];

export const gameScoreMockMoreSportsCategory: MockSportCategoryProps[] = [
  ...mockMoreSportsCategory,
  {
    categoryId: 6,
    key: 'atp-french-open',
    sportActivity: 'Tennis',
    sportTitle: 'ATP French Open',
    sportTitleShort: 'ATP French',
    sportName: 'Tennis',
  },
  {
    categoryId: 6,
    key: 'atp-santa-fe-challenger',
    sportActivity: 'Tennis',
    sportTitle: 'ATP Santa Fe Challenger',
    sportTitleShort: 'ATP Santa',
    sportName: 'Tennis',
  },
  {
    categoryId: 6,
    key: 'atp-lyon-challenger',
    sportActivity: 'Tennis',
    sportTitle: 'ATP Lyon Challenger',
    sportTitleShort: 'ATP Lyon',
    sportName: 'Tennis',
  },
  {
    categoryId: 6,
    key: 'atp-stuttgart',
    sportActivity: 'Tennis',
    sportTitle: 'ATP Stuttgart',
    sportTitleShort: 'ATP Stuttgart',
    sportName: 'Tennis',
  },
  {
    categoryId: 6,
    key: 'atp-ilkley-challenger',
    sportActivity: 'Tennis',
    sportTitle: 'ATP Ilkley Challenger',
    sportTitleShort: 'ATP Ilkley',
    sportName: 'Tennis',
  },
  {
    categoryId: 6,
    key: 'atp-perugia-challenger',
    sportActivity: 'Tennis',
    sportTitle: 'ATP Perugia Challenger',
    sportTitleShort: 'ATP Perugia',
    sportName: 'Tennis',
  },
  {
    categoryId: 6,
    key: 'atp-hertogenbosch',
    sportActivity: 'Tennis',
    sportTitle: 'ATP Hertogenbosch',
    sportTitleShort: 'ATP Hertogenbosch',
    sportName: 'Tennis',
  },
  {
    categoryId: 6,
    key: 'atp-bratislava-challenger',
    sportActivity: 'Tennis',
    sportTitle: 'ATP Bratislava Challenger',
    sportTitleShort: 'ATP Bratislava',
    sportName: 'Tennis',
  },
  {
    categoryId: 6,
    key: 'wta-french-open',
    sportActivity: 'Tennis',
    sportTitle: 'WTA French Open',
    sportTitleShort: 'WTA French Open',
    sportName: 'Tennis',
  },
  {
    categoryId: 6,
    key: 'wta-london',
    sportActivity: 'Tennis',
    sportTitle: 'WTA London',
    sportTitleShort: 'WTA London',
    sportName: 'Tennis',
  },
  {
    categoryId: 6,
    key: 'wta-hertogenbosch',
    sportActivity: 'Tennis',
    sportTitle: 'WTA Hertogenbosch',
    sportTitleShort: 'WTA Hertogenbosch',
    sportName: 'Tennis',
  },
];

export const groupedWomanBasketball = [
  {
    tab: 'WNBA',
    leagues: [
      {
        sportTitle: 'WNBA',
        sportActivity: 'Basketball',
        categoryId: 6,
        tab: 'WNBA',
        id: 1,
      },
      {
        sportTitle: 'WNBA Preseason',
        sportActivity: 'Basketball',
        categoryId: 6,
        tab: 'WNBA',
        id: 2,
      },
      {
        sportTitle: 'WNBA All-Star Game',
        sportActivity: 'Basketball',
        categoryId: 6,
        tab: 'WNBA',
        id: 3,
      },
      {
        sportTitle: 'WNBA Commissioner Cup',
        sportActivity: 'Basketball',
        categoryId: 6,
        tab: 'WNBA',
        id: 4,
      },
    ],
  },
];

export const gameScoreMockSportCategory: MockSportCategoryProps[] = [
  ...mockSportCategory,
  {
    categoryId: 6,
    key: 'wnba-preseason',
    sportActivity: 'Basketball',
    sportTitle: 'WNBA Preseason',
    sportTitleShort: 'WNBA Preseason',
    sportName: 'Basketball',
  },
  {
    categoryId: 6,
    key: 'wnba-all-star-game',
    sportActivity: 'Basketball',
    sportTitle: 'WNBA All-Star Game',
    sportTitleShort: 'WNBA All-Star',
    sportName: 'Basketball',
  },
  {
    categoryId: 6,
    key: 'wnba-commissioner-cup',
    sportActivity: 'Basketball',
    sportTitle: 'WNBA Commissioner Cup',
    sportTitleShort: 'WNBA Commissioner',
    sportName: 'Basketball',
  },
];

export const atpTitles =
  'ATP,ATP French Open,ATP Santa Fe Challenger,ATP Lyon Challenger,ATP Stuttgart,ATP Ilkley Challenger,ATP Perugia Challenger,ATP Hertogenbosch,ATP Bratislava Challenger';

export const wtaTitles = 'WTA,WTA French Open,WTA London,WTA Hertogenbosch';

export const wnbaTitles = 'WNBA,WNBA Preseason,WNBA All-Star Game, WNBA Commissioner Cup';

export const sportHaveDraw = ['soccer', 'cricket'];

export const sportDontHaveImage = ['tennis', 'mma', 'golf'];
